import ApiClient from "./apiClient";
import { QueriesApi } from "./apiTypes";

const currencyService = {
  list: (queries: Partial<QueriesApi> = {}) => {
    const { page, pageSize, page_size, ordering, ...rest } = queries || {};

    return ApiClient.get("currency", {
      params: {
        page,
        ordering,
        page_size: pageSize ?? page_size,
        ...rest,
      },
    });
  },
  create: (payload: Record<string, any>) => ApiClient.post("currency", payload),
  update: (code: string, payload: Record<string, any>) =>
    ApiClient.put(`currency/${encodeURIComponent(code)}`, payload),
  delete: (code: string) =>
    ApiClient.delete(`currency/${encodeURIComponent(code)}`),
  updateExchangeRates: () => ApiClient.post("currency/update_exchange_rates"),
  updateRelativePrices: () => ApiClient.post("currency/update_relative_prices"),
  getCreateOptions: (params: Record<string, any> = {}) =>
    ApiClient.get("currency/create_options", { params }),
  getRatesConnectors: () => ApiClient.get("currency/rates-connectors"),
  updateRatesConnectors: (payload: Record<string, any>) =>
    ApiClient.put("currency/rates-connectors", payload),
};

export default currencyService;
